import { getToken, getCookieTerms } from '../../localStorage';

export const isCookiesTermsUsagesAccepted = () => {
  return getCookieTerms();
};

export const token = () => {
  return `Bearer ${getToken()}`;
};
